module.exports = __webpack_public_path__ + "img/icon.d0577326.svg";